 document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.nav-link');
    const contents = document.querySelectorAll('.tab-content');

    function deactivateAllTabs() {
      tabs.forEach(tab => tab.classList.remove('active'));
      contents.forEach(content => content.style.display = 'none');
    }

    function activateTab(tab) {
      const tabId = tab.getAttribute('data-tab');
      const content = document.getElementById(tabId);

      tab.classList.add('active');
      content.style.display = 'block';

      // Initialize or update Swiper
      const swiperContainer = content.querySelector('.product-slides');
      if (swiperContainer.swiper) {
        swiperContainer.swiper.update();
      } else {
        new Swiper(swiperContainer, {
          loop: true,
          speed: 1000,
          slidesPerView: 4, 
          spaceBetween: 10,
          loopFillGroupWithBlank: true, // Fill empty space with blank slides
          navigation: {
            nextEl: '.collection-swiper-button-next',
            prevEl: '.collection-swiper-button-prev',
          },
          breakpoints: {
            0: {
              slidesPerView: 1.5,
              
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
              centeredSlides: false,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 4,
             
              spaceBetween: 30,
            },
          }
        });
      }
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        deactivateAllTabs();
        activateTab(this);
      });
    });

    if (tabs.length > 0) {
      deactivateAllTabs();
      activateTab(tabs[0]);
    }
  });